<template>
    <BModal :model-value="modal" centered @update:modelValue="updateModal" no-close-on-esc no-close-on-backdrop>
        <template #header>
            <div
                class="d-flex align-items-center justify-content-between modal-title w-100"
            >
                <h5 class="">Guest</h5>
                <BButton
                    variant="link"
                    class="close"
                    @click="updateModal(false)"
                >
                    <i class="ion ion-android-close"></i>
                </BButton>
            </div>
        </template>
        
        <BForm @submit.stop.prevent>
            <BRow v-if="!props.selectedData.uuid" class="mb-4">
                <BCol>
                    <div class="p-3 border rounded bg-light">
                        <BFormGroup label="Select Guest Hotel" class="mb-0 text-start">
                            <v-select
                                v-model="selectedDeliriverGuest"
                                label="fullname"
                                :options="deliriverGuests"
                                :searchable="true"
                                :clearable="true"
                                placeholder="Search by name..."
                                @search="onDeliriverSearch"
                            >
                                <template #no-options="{ search, searching }">
                                    <template v-if="searching">
                                        Searching...
                                    </template>
                                    <template v-else-if="search">
                                        No guests found for "{{ search }}"
                                    </template>
                                    <template v-else>
                                        Type to search guests from Deliriver...
                                    </template>
                                </template>
                                <template #option="option">
                                    {{ option.fullname }} <span class="text-muted small" v-if="option.phone">({{ option.phone }})</span>
                                </template>
                            </v-select>
                        </BFormGroup>
                    </div>
                </BCol>
            </BRow>

            <BRow>
                <BCol cols="4">
                    <BFormGroup
                        label="Alias *"
                        label-for="alias"
                        class="text-start mb-3"
                    >
                        <BFormSelect
                            id="alias"
                            v-model="form.alias"
                            :options="aliasOptions"
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    v$.form.alias.$dirty &&
                                    v$.form.alias.$invalid,
                            }"
                        >
                            <template #first>
                                <option disabled selected value="">
                                    Select Alias
                                </option>
                            </template>
                        </BFormSelect>
                        <BFormInvalidFeedback
                            :state="
                                v$.form.alias.$dirty && v$.form.alias.$invalid
                            "
                        >
                            {{ v$.form.alias.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol cols="8">
                    <BFormGroup
                        label="Full Name *"
                        label-for="name"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.fullname"
                            type="text"
                            id="fullname"
                            placeholder="Enter Full Name"
                            :class="{
                                'is-invalid':
                                    v$.form.fullname.$dirty &&
                                    v$.form.fullname.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.fullname.$dirty &&
                                v$.form.fullname.$invalid
                            "
                        >
                            {{ v$.form.fullname.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="ID/Passport"
                        label-for="identity_number"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.identity_number"
                            type="text"
                            id="identity_number"
                            placeholder="Enter Identity Number"
                            :class="{
                                'is-invalid':
                                    v$.form.identity_number.$dirty &&
                                    v$.form.identity_number.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.identity_number.$dirty &&
                                v$.form.identity_number.$invalid
                            "
                        >
                            {{ v$.form.identity_number.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="No Contact"
                        label-for="phone"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.phone"
                            type="text"
                            id="phone"
                            placeholder="Enter No Contact"
                            :class="{
                                'is-invalid':
                                    v$.form.phone.$dirty &&
                                    v$.form.phone.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.phone.$dirty && v$.form.phone.$invalid
                            "
                        >
                            {{ v$.form.phone.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Nationality"
                        label-for="nationality"
                        class="text-start mb-3"
                    >
                        <v-select
                            v-model="form.nationality"
                            label="label"
                            :options="nationalityList"
                            :reduce="(item) => item.label"
                            :searchable="true"
                            :clearable="true"
                            :taggable="true"
                            placeholder="Select or Type Nationality"
                            :class="{
                                'is-invalid':
                                    v$.form.nationality.$dirty &&
                                    v$.form.nationality.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.nationality.$dirty &&
                                v$.form.nationality.$invalid
                            "
                        >
                            {{ v$.form.nationality.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
                <BCol>
                    <BFormGroup
                        label="City"
                        label-for="city"
                        class="text-start mb-3"
                    >
                        <BFormInput
                            v-model="form.city"
                            type="text"
                            id="city"
                            placeholder="Enter City"
                            :class="{
                                'is-invalid':
                                    v$.form.city.$dirty &&
                                    v$.form.city.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.city.$dirty && v$.form.city.$invalid
                            "
                        >
                            {{ v$.form.city.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Address"
                        label-for="address"
                        class="text-start mb-3"
                    >
                        <BFormTextarea
                            v-model="form.address"
                            type="text"
                            id="address"
                            placeholder="Enter Address"
                            :class="{
                                'is-invalid':
                                    v$.form.address.$dirty &&
                                    v$.form.address.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.address.$dirty &&
                                v$.form.address.$invalid
                            "
                        >
                            {{ v$.form.address.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
            <BRow>
                <BCol>
                    <BFormGroup
                        label="Identity Photo"
                        label-for="identity_photo"
                        class="text-start mb-3"
                    >
                        <BFormFile
                            v-model="form.identity_photo"
                            @change="e => form.identity_photo = e.target.files[0]"
                            id="identity_photo"
                            :class="{
                                'is-invalid':
                                    v$.form.identity_photo.$dirty &&
                                    v$.form.identity_photo.$invalid,
                            }"
                        />
                        <BFormInvalidFeedback
                            :state="
                                v$.form.identity_photo.$dirty &&
                                v$.form.identity_photo.$invalid
                            "
                        >
                            {{ v$.form.identity_photo.$errors[0]?.$message }}
                        </BFormInvalidFeedback>
                    </BFormGroup>
                </BCol>
            </BRow>
        </BForm>

        <template #footer>
            <div class="d-flex justify-content-end">
                <BButton variant="primary" class="me-2" @click="handleAction"
                    >Save</BButton
                >
                <BButton variant="danger" @click="updateModal(false)"
                    >Cancel</BButton
                >
            </div>
        </template>
    </BModal>
</template>

<script setup>
import axios from "axios";
import { defineProps, defineEmits, reactive, watch, ref, onMounted } from "vue";
import {
    BModal,
    BRow,
    BCol,
    BForm,
    BFormInput,
    BButton,
    BFormGroup,
    BFormInvalidFeedback,
    BFormTextarea,
    BFormFile,
    BFormSelect,
} from "bootstrap-vue-next";
import { useVuelidate } from "@vuelidate/core";
import { helpers, required, minLength } from "@vuelidate/validators";
import { useLoading } from "vue-loading-overlay";
import { useAuthStore } from "@/store/auth.js";
import { useToast } from "vue-toastification";
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";

const auth = useAuthStore();
const $loading = useLoading();
const toast = useToast();

// Props
const props = defineProps({
    action: String,
    modal: Boolean,
    selectedData: Object,
});

// Deliriver State
const deliriverGuests = ref([]);
const selectedDeliriverGuest = ref(null);

let searchTimeout = null;

const onDeliriverSearch = (search, loading) => {
    if (search.length < 3) return; // Minimum 3 characters to trigger API
    loading(true);
    
    // Clear the previous timeout
    if (searchTimeout) clearTimeout(searchTimeout);
    
    // Set a new timeout (debounce)
    searchTimeout = setTimeout(async () => {
        try {
            const DELI_RIVER_URL = 'https://bedeliriver.management-deliriver.com/api/trijaya/guests';
            const SECRET_TOKEN = 'secret_management_trijaya_123';
            
            const response = await axios.get(DELI_RIVER_URL, {
                params: { keyword: search },
                headers: {
                    'Accept': 'application/json',
                    'X-Trijaya-Token': SECRET_TOKEN
                }
            });
            
            const resData = response.data;
            deliriverGuests.value = resData.data || [];
        } catch (e) {
            console.error("Deliriver search error:", e);
            toast.error("Failed to search Deliriver guests.");
        } finally {
            loading(false);
        }
    }, 500); // Wait 500ms after user stops typing
};

const autoFillDeliriverGuest = (guest) => {
    if (!guest) return;
    
    // Check if the guest variable is an object (it should be since v-select without :reduce returns the full object)
    if (typeof guest !== 'object') {
       console.error("Expected an object from v-select, got:", guest);
       return;
    }
    
    // Auto-fill mapped fields
    form.fullname = guest.fullname || "";
    form.alias = guest.alias ? (guest.alias.charAt(0).toUpperCase() + guest.alias.slice(1).toLowerCase()) : "";
    if (!aliasOptions.some(opt => opt.value === form.alias)) {
        form.alias = ""; // Fallback if alias from API doesn't match our options
    }
    form.identity_number = guest.identity_number || "";
    form.phone = guest.phone || "";
    form.address = guest.address || "";
    form.city = guest.city || "";
    form.nationality = guest.nationality || "";
    form.accurate_id = guest.accurate_id || "";
    
    toast.info("Form auto-filled from Deliriver data.");
};

watch(selectedDeliriverGuest, (newGuest) => {
    if (newGuest) {
        autoFillDeliriverGuest(newGuest);
    }
});

const aliasOptions = [
    {
        value: "Mr",
        text: "Mr",
    },
    {
        value: "Ms",
        text: "Ms",
    },
    {
        value: "Mrs",
        text: "Mrs",
    },
    {
        value: "Pty",
        text: "Pty",
    },
];

// Emit
const emit = defineEmits(["update:modal", "addOrUpdate"]);

// Function to update modal visibility
const updateModal = (value) => {
    emit("update:modal", value); // Sync modal state with parent
};

const resetForm = () => {
    Object.assign(form, { ...formData });
    v$.value.$reset();
    selectedDeliriverGuest.value = null; // Reset deliriver selection
};

const formData = {
    alias: "",
    fullname: "",
    identity_number: "",
    address: "",
    phone: "",
    city: "",
    nationality: "",
    identity_photo: "",
    accurate_id: "",
};

const form = reactive({ ...formData });

// Init data jika update
watch(
    () => props.selectedData,
    (newData) => {
        // jika props.selectedData != null (action edit)
        if (newData && Object.keys(newData).length > 0) {
            const guestData = {
                ...newData,
                identity_photo: "",
            };
            Object.assign(form, { ...guestData });
        } else {
            Object.assign(form, { ...formData });
        }
    },
    { immediate: true }
);

const rules = {
    form: {
        alias: {
            required: helpers.withMessage("Alias is required", required),
        },
        fullname: {
            required: helpers.withMessage("Fullname is required", required),
            minLength: helpers.withMessage(
                "Fullname must be at least 3",
                minLength(3)
            ),
        },
        identity_number: {},
        nationality: {},
        address: {},
        phone: {},
        city: {},
        identity_photo: {},
    },
};

const v$ = useVuelidate(rules, { form });

const handleAction = () => {
    props.selectedData.uuid ? update() : create();
};

const create = async () => {
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });

        try {
            const response = await axios.post(
                `${process.env.VUE_APP_API_URL}/guest/add`,
                {
                    alias: form.alias,
                    fullname: form.fullname,
                    identity_number: form.identity_number,
                    address: form.address,
                    phone: form.phone,
                    city: form.city,
                    nationality: form.nationality,
                    identity_photo: form.identity_photo,
                    accurate_id: form.accurate_id,
                },
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                emit("addOrUpdate");
                toast.success(res.message);
                updateModal(false);
                resetForm();
            }
        } catch (e) {
            console.log(e);
        } finally {
            loader.hide();
        }
    }
};

const update = async () => {
    v$.value.$touch();
    if (!v$.value.$invalid) {
        const loader = $loading.show({
            color: "#489464",
            loader: "spinner",
        });
        try {
            const response = await axios.post(
                `${process.env.VUE_APP_API_URL}/guest/edit/${props.selectedData.uuid}`,
                {
                    alias: form.alias,
                    fullname: form.fullname,
                    identity_number: form.identity_number,
                    address: form.address,
                    phone: form.phone,
                    city: form.city,
                    nationality: form.nationality,
                    identity_photo: form.identity_photo ?? null,
                    accurate_id: form.accurate_id,
                },
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: "Bearer " + auth._token,
                    },
                }
            );

            const res = response.data;

            if (res.status) {
                emit("addOrUpdate");
                toast.success(res.message);
                updateModal(false);
                resetForm();
            }
        } finally {
            loader.hide();
        }
    }
};

let nationalityList = ref([]);

const getAllNationality = async () => {
    const loader = $loading.show({
        color: "#489464",
        loader: "spinner",
    });
    try {
        const response = await axios.get(
            `${process.env.VUE_APP_API_URL}/country`,
            {
                headers: {
                    "Content-type": "application/json",
                    Authorization: "Bearer " + auth._token,
                },
            }
        );

        const res = response.data;

        if (res.status === 'success') {
            nationalityList.value = res.data.map(
                (item) => ({
                    value: item.uuid,
                    label: item.country,
                })
            );
        }
    } finally {
        loader.hide();
    }
};

onMounted(() => {
    if (nationalityList.value != null || nationalityList.value != "") {
        getAllNationality();
    }
});
</script>
